





















import { Component, Vue, Prop } from 'vue-property-decorator';
import { User } from '@pjn/core/model/app/User';
import { newTab } from '@pjn/utils/browser';
import { item, number } from '@pjn/utils/random';
import Balloon from '../Balloon.vue';
import UserIcon from './UserIcon.vue';
import { BooleanProp } from '@pjn/vue-core/component';

/**
 * Componente de usuario.
 * 
 * Muestra el icono con el avatar/inicial del usuario y al presionarlo, muestra el menu de opciones en un Balloon.
 * 
 * Normalmente se usa en un ```<Toolbar />```
 */
@Component({ components: { Balloon, UserIcon } })
export default class UserComponent extends Vue {
  
  /** Usuario a mostrar */
  @Prop() user: User;

  /** Mostrar nombre al lado del icono */
  @BooleanProp(false) showName: boolean;

  private onProfileClick() {
    if(this.$listeners.profileClick) {
      this.$emit('profileClick');
    } else {
      newTab('http://portalpjn.pjn.gov.ar', 'Navegando a la pagina de perfil');
    }
  }

  private get backgroundClasses() {
    return `${item(['red', 'blue', 'green', 'teal', 'deep-orange'])} darken-${parseInt(number(3)) + 1}`;
  }
}
